import React from "react";

import {
  emitEventClick,
  EVENT_RECOMMENDER_EVENT_TYPE,
} from "@catchoftheday/analytics";
import { EventCard } from "@catchoftheday/cg-components";

import { InteractionTrackingData } from "../types";

type EventCardType = {
  id: string;
  title: string;
  badgeText?: string | null;
  url: string;
  image: EventImage;
  product?: {
    id: string;
  } | null;
};

type EventImage = {
  single: {
    url: string;
    altText: string;
  };
};

type GetEventTilesProps = InteractionTrackingData & {
  events: EventCardType[];
};

export const getEventTiles = ({
  events,
  sourceType,
  fromProduct,
}: GetEventTilesProps): React.ReactNode[] => {
  const handleEventClick = ({
    event,
    position,
  }: {
    event: EventCardType;
    position: number;
  }) => {
    emitEventClick({
      title: event.title,
      subtitle: null,
      source_type: sourceType,
      badge_text: event.badgeText,
      event_id: Number(event.id),
      position: position,
      event_type: EVENT_RECOMMENDER_EVENT_TYPE,
      schedule_entry_id: 0,
      click_target: event?.product ? "product" : "event",
      ...fromProduct,
    });
  };
  return events.map((event, index) => {
    const {
      id,
      title,
      badgeText,
      url,
      image: { single },
    } = event;
    return (
      <EventCard
        key={id}
        title={title}
        badgeText={badgeText}
        url={url}
        image={{
          url: single.url,
          altText: single.altText,
        }}
        mx={{ xs: "2px", md: "10px" }}
        my="2px"
        onClick={() => handleEventClick({ event, position: index + 1 })}
      />
    );
  });
};
